import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, Package } from "lucide-react";
import { api, formatINR } from "@/api";
import { trackPurchase } from "@/lib/analytics";

export default function OrderSuccess() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderId}`).then(({ data }) => {
      setOrder(data);
      trackPurchase(data);
    }).catch(() => {});
  }, [orderId]);

  return (
    <div className="container-ping py-20 max-w-2xl mx-auto text-center" data-testid="order-success-page">
      <CheckCircle2 className="h-20 w-20 mx-auto text-[#E31837]" strokeWidth={1.2} />
      <h1 className="heading-1 mt-6">Order Confirmed</h1>
      <p className="text-muted-foreground mt-3">
        Thank you for your order. A confirmation has been recorded and our team will be in touch shortly.
      </p>
      <p className="mt-2 label-caps" data-testid="order-id">Order #{orderId?.slice(0, 8).toUpperCase()}</p>

      {order && (
        <div className="mt-10 border border-border text-left" data-testid="order-details">
          <div className="flex items-center gap-2 p-4 bg-[#0A0A0A] text-white">
            <Package className="h-5 w-5" />
            <span className="label-caps">Order Details</span>
            <span className={`ml-auto label-caps px-2 py-1 ${order.status === "paid" ? "bg-green-600" : "bg-[#E31837]"}`}>
              {order.status === "paid" ? "Paid" : "Pending Payment"}
            </span>
          </div>
          <div className="divide-y divide-border">
            {order.items.map((i, idx) => (
              <div key={`${i.product_id}-${i.variant || ""}-${i.customization || ""}-${idx}`} className="flex items-center gap-3 p-4">
                <img src={i.image} alt={i.name} className="w-14 h-14 object-cover bg-secondary border border-border" />
                <div className="flex-1">
                  <p className="font-semibold text-sm">{i.name}</p>
                  {i.variant && <p className="text-xs text-muted-foreground">{i.variant}</p>}
                  {i.customization && <p className="text-xs text-muted-foreground">Personalization: “{i.customization}”</p>}
                  <p className="text-xs text-muted-foreground">Qty {i.quantity}</p>
                </div>
                <span className="font-semibold text-sm">{formatINR(i.price * i.quantity)}</span>
              </div>
            ))}
          </div>
          <div className="p-4 flex justify-between border-t border-border">
            <span className="font-head font-bold uppercase">Total</span>
            <span className="font-bold">{formatINR(order.total)}</span>
          </div>
        </div>
      )}

      <Link to="/shop" className="mt-10 inline-block bg-[#0A0A0A] text-white px-10 py-4 label-caps btn-transition hover:bg-black/80 active:scale-95" data-testid="back-to-shop">
        Continue Shopping
      </Link>
    </div>
  );
}
